"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Box_1 = require("./Box");
var ScrollThroughIntersectionDetector_1 = __importDefault(require("./utilComponents/ScrollThroughIntersectionDetector"));
var ImageContainer = (0, Box_1.createBasicComponent)({
    // image reset
    display: 'block',
    maxWidth: '100%'
});
ImageContainer.defaultProps = { as: 'img' };
exports.default = react_1.default.forwardRef(function Image(props, ref) {
    var lazy = props.lazy, _a = props.motivation, motivation = _a === void 0 ? 'NORMAL' : _a, src = props.src, rest = __rest(props, ["lazy", "motivation", "src"]);
    var _b = (0, react_1.useState)(), loadedSrc = _b[0], setLoadedSrc = _b[1];
    // return regular image if no lazy load
    if (!lazy) {
        return (react_1.default.createElement(ImageContainer, __assign({}, rest, { ref: ref, src: src })));
    }
    /* ---------- lazy load section ----------------------*/
    var handleScrollThrough = function () {
        setLoadedSrc(src);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !loadedSrc && react_1.default.createElement(ScrollThroughIntersectionDetector_1.default, { onScrollThrough: handleScrollThrough, offset: getOffset(motivation) }),
        react_1.default.createElement(ImageContainer, __assign({}, rest, { ref: ref, src: loadedSrc }))));
});
function getOffset(motivation) {
    switch (motivation) {
        case 'EAGER':
            return 1200;
        case 'NORMAL':
            return 900;
        case 'LATE':
            return 0;
        default:
            return 0;
    }
}
